import { FC } from 'react'

import { match } from 'ts-pattern'

import { Badge } from '@sequencehq/core-components'

export type PublishedBadgeStatus =
  | 'published'
  | 'unpublishedChanges'
  | 'unpublished'

export const PublishedBadge: FC<{ status: PublishedBadgeStatus }> = ({
  status
}) =>
  match(status)
    .with('published', () => (
      <Badge data-testid="automations.publishedBadge" sentiment="success">
        Published
      </Badge>
    ))
    .with('unpublishedChanges', () => (
      <Badge data-testid="automations.publishedBadge" sentiment="highlight">
        Unpublished changes
      </Badge>
    ))
    .with('unpublished', () => (
      <Badge data-testid="automations.publishedBadge">Unpublished</Badge>
    ))
    .exhaustive()
